export enum InvoiceSortColumn {
  salesRepresentative = 1,
  name = 2,
  invoiceDate = 3,
  poNumber = 4,
  totalAmount = 5
}

export enum InvoiceSortDirection {
  none = 0,
  asc = 1,
  desc = 2
}
